import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './IOSInstallModal.css';

const IOSInstallModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="ios-modal-overlay" onClick={onClose}>
          <motion.div
            className="ios-modal-content"
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50, scale: 0.95 }}
            transition={{ type: 'spring', damping: 25, stiffness: 350 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="ios-modal-close" onClick={onClose} aria-label="Close">
              <FaTimes />
            </button>

            <div className="ios-modal-header">
              <img src="/logo192.png" alt="Mittral Life Science Logo" className="ios-modal-logo" />
              <h2>Install Mittral Life</h2>
              <p>Add the app to your home screen for fast, offline-capable access to our services and products.</p>
            </div>

            <div className="ios-modal-steps">
              <div className="ios-step">
                <div className="ios-step-number">1</div>
                <div className="ios-step-text">
                  Tap the <strong>Share</strong> button in Safari's bottom browser bar.
                  <span className="ios-icon-inline">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="share-icon-svg">
                      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                      <polyline points="16 6 12 2 8 6" />
                      <line x1="12" y1="2" x2="12" y2="15" />
                    </svg>
                  </span>
                </div>
              </div>

              <div className="ios-step">
                <div className="ios-step-number">2</div>
                <div className="ios-step-text">
                  Scroll down the options and select <strong>Add to Home Screen</strong>.
                  <span className="ios-icon-inline">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="add-icon-svg">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                  </span>
                </div>
              </div>

              <div className="ios-step">
                <div className="ios-step-number">3</div>
                <div className="ios-step-text">
                  Tap <strong>Add</strong> in the top-right corner to complete the installation.
                </div>
              </div>
            </div>

            <button className="ios-modal-btn" onClick={onClose}>
              Got It
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default IOSInstallModal;
